"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceRange = void 0;
const priceRange = (price_range) => {
    if (!price_range)
        return null;
    switch (price_range.toLowerCase()) {
        case "premium":
            return "$$$$";
        case "expensive":
            return "$$$";
        case "moderate":
            return "$$";
        case "budget":
            return "$";
    }
};
exports.priceRange = priceRange;
